module.exports = __webpack_public_path__ + "static/media/favourite-empty.dacf9bc0.svg";